module.exports = __webpack_public_path__ + "static/media/calculator.8f3b9f5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calculator.jpg
// module id = 74
// module chunks = 0